import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteParameter } from "../../services/parameter";
import { toast } from "react-toastify";

const useDeleteParameter = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteParameter,

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["categories"] });
                toast.success("Parameter deleted successfully");
            }
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteParameter;